import {
  doc,
  writeBatch,
  serverTimestamp,
  increment,
  getDoc,
} from "firebase/firestore";
import { db } from "../../firebase/firebase";

export async function assignPacketToStudents({
  packet,
  studentIds,
  tutorUid,
}) {
  const packetId = packet.id || packet.packetId;

  if (!packetId) {
    throw new Error("assignPacketToStudents: packetId missing");
  }

  if (!studentIds || studentIds.length === 0) return;

  const packetRef = doc(db, "packets", packetId);
  const packetSnap = await getDoc(packetRef);

  if (!packetSnap.exists()) {
    throw new Error(`Packet ${packetId} not found in Firestore`);
  }

  const packetData = packetSnap.data();

  const batch = writeBatch(db);

  studentIds.forEach((studentId) => {
    const assignmentRef = doc(
      db,
      "users",
      studentId,
      "assignments",
      packetId
    );

    batch.set(assignmentRef, {
      packetId,
      packetName: packetData.name,
      section: packetData.section,
      questionCount: packetData.questionCount,
      estimatedMinutes: packetData.estimatedMinutes,
      assignedBy: tutorUid,
      assignedAt: serverTimestamp(),
      status: "assigned",
      calculatorAllowed: false,
    });
  });

  const statsRef = doc(db, "packetStats", packetId);

  batch.set(
    statsRef,
    {
      assignedCount: increment(studentIds.length),
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );

  await batch.commit();
}
